// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3YbjZ","footer":"ModalInfo_footer__1hdZf"};